import {dispatchError} from "../../utils/error_handling";
import {ContentProvider, ContentProviderType} from "../../../../domain/entities/content-provider/content-provider";
import store from "../../../repository/store/store";
import router from "../../../../src/routes";

const maximumTimeReachedError = "Você esgotou o tempo limite para fazer o questionário.";
export const questionErrorHandler = async (e: Error): Promise<void> => {
  switch (e.message) {
    case maximumTimeReachedError:
      await onMaximumTimeReachedError(e);
      return;
  }
  await dispatchError(e);
};

export const onMaximumTimeReachedError = async (e: Error): Promise<void> => {
  try {
    await finishQuestionnaire();
    await showMaximumTimeReachedModal();
    await reloadContent();
    await redirectToQuestionnaireCover();
  } catch (e) {
    console.error("[onMaximumTimeReached] Error ", e);
    await dispatchError(e);
  }
};

export const finishQuestionnaire = async (): Promise<void> => {
  try {
    await store.dispatch("content_module/exercise/finishQuestionnaire");
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const showMaximumTimeReachedModal = async (): Promise<void> => {
  try {
    await store.dispatch(
      "alert_box_module/open",
      "O tempo para conclusão do exercício acabou."
    );
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const redirectToQuestionnaireCover = async () => {
  try {
    const contentProvider = store.getters["content_module/contentProvider"] as ContentProvider;
    const currentRoute = router.currentRoute.value;
    if (!currentRoute) return;

    const courseID = currentRoute.params.course_id;
    const eventID = currentRoute.params.event_id;
    const classID = currentRoute.params.class_id;
    const contentID = currentRoute.params.content_id;

    switch (contentProvider.getType()) {
      case ContentProviderType.COURSE:
        await router.push({name: "course_content", params: {course_id: courseID, content_id: contentID}});
        break;
      case ContentProviderType.EVENT:
        await router.push({
          name: "event_content",
          params: {event_id: eventID, class_id: classID, content_id: contentID}
        });
        break;
    }
  } catch (e) {
    console.error("[redirectToQuestionnaireCover] Error ", e);
    throw e;
  }
};

/** This serves to update the result on the QuestionnaireCover view.
 * TODO: Find a better way to do that. */
export const reloadContent = async (): Promise<void> => {
  try {
    const currentRoute = router.currentRoute.value;
    await store.dispatch("content_module/setCurrentContent", currentRoute.params.content_id);
  } catch (e) {
    console.error("[setCurrentContent] Error dispatch ", e);
    throw e;
  }
};

    /** This serves to update the content listing .
     * TODO: Find a better way to do that. */
    export const reloadContentList = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/loadAllContents");
      } catch (e) {
        console.error("[reloadContentList] Error dispatch ", e);
        throw e;
      }
    };